export interface FitterResource {
  name: string;
  active: boolean;
}
